// components/PageWrapper.jsx
import { motion } from "framer-motion";
import { FaRocket, FaGithub } from "react-icons/fa";

const variants = {
  initial: { opacity: 0, y: -100, scale: 1.1 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.16, // etwas flüssiger
      duration: 0.55,
      ease: "easeInOut"
    }
  },
  exit: { opacity: 0, y: 100, scale: 1.05, transition: { duration: 0.4 } }
};

const childVariants = {
  initial: { opacity: 0, y: 20, filter: "blur(8px)" },
  animate: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      filter: { duration: 0.36 },
      y: { duration: 0.44 },
      opacity: { duration: 0.4 }
    }
  },
  exit: { opacity: 0, y: 100, filter: "blur(100px)", transition: { duration: 0.25 } }
};

export default function PageWrapper({
  children,
  className = "",
  style = {},
  animateChildren = true, // neuer prop
  layout = false, // nur bei Bedarf aktivieren!
  ...rest
}) {
  return (
    <>
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants}
        className={`relative ${className}`}
        style={style}
        {...(layout ? { layout } : {})}
        {...rest}
      >
        {Array.isArray(children)
          ? children.map((child, i) =>
              animateChildren ? (
                <motion.div key={child?.key ?? i} variants={childVariants}>
                  {child}
                </motion.div>
              ) : (
                <>{child}</>
              )
            )
          : animateChildren ? (
              <motion.div variants={childVariants}>{children}</motion.div>
            ) : (
              <>{children}</>
            )}
      </motion.div>

      {/* Global Corner Badge seite links zenstudio */}
      <div className="fixed left-0 top-36 z-50 group">
        <div className="origin-left transform -translate-x-[85%] 
        group-hover:translate-x-[0%] group-focus-within:translate-x-0 
        transition-transform duration-500 will-change-transform">
          <a
            href="https://github.com/THEORIGINALBITTER/zenpost-studio/releases/tag/ZenPost"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex flex-row-reverse items-center gap-2 
            mt-10 bg-[#b09062] rounded-r-lg 
             text-slate-800 px-6 py-2 
             text-[11px] uppercase tracking-[0.2em] 
             font-mono font-semibold shadow-sm shadow-black/70 hover:shadow-sm 
             transition-shadow focus-visible:outline-dotted hover:border-r-4 hover:border-slate-800 focus-visible:ring-2 focus-visible:ring-[#b09062]/80"
          >
            <span className="text-base leading-none text-slate-800 ">< FaGithub /></span>
            ZenPost Studio Release 1.0
          </a>
        </div>
      </div>
    </>
  );
}
